import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const TILES = [
    { to: "/admin/users", label: "Users & advertisers" },
    { to: "/admin/surveys", label: "Surveys" },
    { to: "/admin/extension-requests", label: "Extension requests" },
    { to: "/admin/payouts", label: "Payouts" },
    { to: "/admin/audit", label: "Audit log" },
    { to: "/admin/config", label: "Configuration" },
    { to: "/admin/kb", label: "Knowledge base" },
];

export default function AdminDashboard() {
    const { user } = useAuth();
    const [overview, setOverview] = useState({});

    useEffect(() => {
        api.get("/admin/analytics/overview").then((r) => setOverview(r.data || {}));
    }, []);

    return (
        <div className="bg-paper min-h-screen">
            <Navbar />
            <main className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
                <p className="eyebrow mb-2">ADMIN CONTROL</p>
                <h1 className="h2 mb-8" data-testid="admin-welcome">Welcome, {user?.name}.</h1>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-0 border border-ink-200 mb-10">
                    <Stat label="Members" value={overview.users_total} alert={overview.users_pending} alertLabel={`${overview.users_pending} pending`} />
                    <Stat label="Advertisers" value={overview.advertisers_total} alert={overview.advertisers_pending} alertLabel={`${overview.advertisers_pending} pending`} />
                    <Stat label="Live surveys" value={overview.surveys_live} alert={overview.surveys_submitted} alertLabel={`${overview.surveys_submitted} to review`} />
                    <Stat label="Payouts" value={overview.payouts_paid} alert={overview.payouts_pending} alertLabel={`${overview.payouts_pending} pending`} />
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-0 border border-ink-200">
                    {TILES.map((t) => (
                        <Link key={t.to} to={t.to} className="p-8 border-r border-b border-ink-200 hover:bg-cream" data-testid={`admin-tile-${t.to.split("/").pop()}`}>
                            <div className="font-heading font-bold text-xl">{t.label}</div>
                            <div className="font-mono text-[10px] text-ink-600 mt-2">→ OPEN</div>
                        </Link>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}

function Stat({ label, value, alert, alertLabel }) {
    return (
        <div className="p-6 border-r border-ink-200 last:border-r-0">
            <div className="text-xs uppercase tracking-wider text-ink-600 mb-1">{label}</div>
            <div className="font-mono text-4xl">{value ?? "—"}</div>
            {alert > 0 && <div className="font-mono text-xs text-warning mt-1">⚠ {alertLabel}</div>}
        </div>
    );
}
